var $be993a68bccef72a$exports = {};
$be993a68bccef72a$exports = {
    "pending": `\u{5F85}\u{8655}\u{7406}`
};


export {$be993a68bccef72a$exports as default};
//# sourceMappingURL=zh-TW.module.js.map
